import axios from "axios";

export class PurchaseSummary extends ProgressIndicator {
	private readonly purchaseSummary: JQuery;
	private readonly couponCodeModal: JQuery;

	constructor(containerId: DOMElementIdentifier, _constructionParameters: ConstructionParameters) {
		super(jQuery("#" + containerId)[0]);

		this.purchaseSummary = jQuery("#" + containerId);

		this.couponCodeModal = jQuery(".modal.mia-couponCodeModal");
		this.couponCodeModal.on("show.bs.modal", this.onCouponCodeModalShow.bind(this));

		this.purchaseSummary.on("updatePurchaseSummary", (event) => void this.onUpdate(event));
	}

	private onCouponCodeModalShow(_event: JQuery.Event) {
		jQuery("input")[0].focus();
	}

	private async onUpdate(_event: JQuery.Event): Promise<void> {
		this.couponCodeModal.modal("hide");
		this.showProgressIndicator(true, "", false);
		const url = this.purchaseSummary.data("update-url");
		try {
			const { data } = await axios.get(url);
			this.onUpdateSucceeded(data);
		}
		finally {
			this.hideProgressIndicator();
		}
	}

	private onUpdateSucceeded(data: any) {
		if (data.success) {
			this.purchaseSummary.replaceWith(data.newPurchaseSummary);
		}
	}
}
